import { createApp } from 'vue'
import App from './App.vue'

import '@/assets/style/tailwind.css'
// axios
import axios from 'axios'
import VueAxios from 'vue-axios'
// pinia store
import { createPinia } from 'pinia'
// vue router
import { createWebHashHistory, createRouter } from 'vue-router'
// vue smoth scroll to
import VueSmoothScroll from 'vue3-smooth-scroll'
// import lazy load images
import VueLazyload from '@jambonn/vue-lazyload'

// import routes
import Questionaire from '@/pages/Questionaire.vue'
import Result from '@/pages/Result.vue'
import Ambiguous from '@/pages/Ambiguous.vue'
import { Config } from './types/config'

// create routes
const routes = [
  // TODO: catch / route
  { path: '/', component: Questionaire, name: 'home' },
  {
    path: '/skintest',
    redirect: { name: 'start', params: { id: 1 } },
    children: [
      { path: ':id', component: Questionaire, name: 'start' },
      {
        path: 'result',
        component: Result,
        name: 'result',
      },
      {
        path: 'ambiguous',
        component: Ambiguous,
        name: 'ambiguous',
      },
    ],
  },
]

const mountEl = document.querySelector('#skin-test') as HTMLElement
// create base app
const app = createApp(App, { ...mountEl?.dataset })
app.config.globalProperties = { ...mountEl?.dataset }
const config = app.config.globalProperties as Config
app.provide<Config>('config', config)

let history = createWebHashHistory()

// create router
const router = createRouter({
  history,
  routes, // short for `routes: routes`
})

// add all plugins to vue context
app.use(VueAxios, axios)
app.use(createPinia())
app.use(router)
app.use(VueSmoothScroll, {
  updateHistory: false,
  container: '.skin-test',
  offset: -200,
})
app.use(VueLazyload)

// provide axios for global use
app.provide('axios', app.config.globalProperties.axios)

// mount app if window is ready

if ((typeof mercury as any) !== 'undefined') {
  mercury.ready(app.mount('#skin-test'))
} else {
  app.mount('#skin-test')
}
